import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardInfo} from './dashboard/dashboard.component';
import { FormsModule }   from '@angular/forms';
import { DashboardService }          from './dashboard.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { 
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatTooltipModule } from '@angular/material';
import { CashOnlyDialog } from './dashboard/dashboard.component';

@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  imports: [
        CommonModule,
        BrowserAnimationsModule,
        DashboardRoutingModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatProgressBarModule
  ],
  providers: [DashboardService],  
  declarations: [DashboardComponent, DashboardInfo, CashOnlyDialog],
  bootstrap: [DashboardInfo]
})
export class DashboardModule { }



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.module.ts